import React from "react";
import { useTranslation } from "react-i18next";
import { IoClose } from "react-icons/io5";
import AddGearItemForm from "../pages/Profilo/AddGearItemForm";

interface AddGearItemModalProps {
  isOpen: boolean;
  onClose: () => void;
  gearpalId: number;
}

export default function AddGearItemModal({
  isOpen,
  onClose,
  gearpalId,
}: AddGearItemModalProps) {
  const { t } = useTranslation();

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 bg-black/80 backdrop-blur-sm flex items-center justify-center p-4 z-[2000]"
      onClick={(e) => e.target === e.currentTarget && onClose()}
    >
      <div className="bg-[#2D1B4E] border border-[#6E11B04D] rounded-2xl shadow-2xl max-w-lg w-full max-h-[90vh] overflow-y-auto p-4 md:p-8 text-white relative custom-scrollbar">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-gray-400 hover:text-white transition-colors p-1"
        >
          <IoClose size={24} />
        </button>

        <h2 className="text-xl font-bold mb-6">
          {t("forms.addItem", "Aggiungi Articolo")}
        </h2>

        <AddGearItemForm gearpalId={gearpalId} onSuccess={onClose} />
      </div>
    </div>
  );
}
